"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patch = exports.del = exports.put = exports.post = exports.get = exports.api = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("./constants");
// Create an instance of axios with a custom config if needed
const api = axios_1.default === null || axios_1.default === void 0 ? void 0 : axios_1.default.create({
    baseURL: constants_1.BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": constants_1.SUBSCRIPTION_KEY
    },
});
exports.api = api;
// Common function for making GET requests
function get(url, config) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get(url, config);
            return response.data;
        }
        catch (error) {
            handleApiError(error);
            return null;
        }
    });
}
exports.get = get;
// Common function for making POST requests
function post(url, data, config) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.post(url, data, config);
            return response.data;
        }
        catch (error) {
            if (error && ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.headers)) {
                const contentType = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.headers["content-type"];
                if (contentType && (contentType === null || contentType === void 0 ? void 0 : contentType.includes("text/html"))) {
                    // handleHtmlResponse(response.data); // Handle the HTML response here
                    return error;
                }
            }
            const errorResponse = error === null || error === void 0 ? void 0 : error.response;
            if (error.code === 'ECONNABORTED') {
                return error;
            }
            else if (errorResponse) {
                const errorStatus = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.status;
                if (errorStatus && errorStatus >= 500) {
                    return error;
                }
            }
            return (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data;
        }
    });
}
exports.post = post;
// Common function for making PUT requests
function put(url, data, config) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.put(url, data, config);
            return response.data;
        }
        catch (error) {
            handleApiError(error);
            return null;
        }
    });
}
exports.put = put;
// Common function for making PATCH requests
function patch(url, data, config) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(url, data, config);
            return response.data;
        }
        catch (error) {
            handleApiError(error);
            return null;
        }
    });
}
exports.patch = patch;
// Common function for making DELETE requests
function del(url, config) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.delete(url, config);
            return response.data;
        }
        catch (error) {
            handleApiError(error);
            return null;
        }
    });
}
exports.del = del;
// Common function to handle API errors
function handleApiError(error) {
    if (axios_1.default.isAxiosError(error)) {
        const axiosError = error;
        if (axiosError.response) {
            // The request was made, but the server responded with an error status code
            console.error("API Response Error:", axiosError.response.data);
        }
        else if (axiosError.request) {
            // The request was made but no response was received
            console.error("API Request Error:", axiosError.request);
        }
        else {
            // Something happened in setting up the request that triggered an error
            console.error("API Error:", axiosError.message);
        }
        // You can add custom error handling logic here
        // For example, you might want to show error messages to the user.
        // You can use a state management library like Redux to store and manage error messages.
    }
    else {
        console.error("Unknown Error:", error);
    }
}
